import { createFileRoute } from '@tanstack/react-router'
import { useParams } from '@tanstack/react-router'
import PlotForm from '@/components/rx/PlotForm';

export const Route = createFileRoute(
  '/dashboard/fields/$fieldId/rx/$rxId/plots/$pairId',
)({
  component: RouteComponent,
})

function RouteComponent() {
    const { fieldId, rxId, pairId } = useParams({
      from: '/dashboard/fields/$fieldId/rx/$rxId/plots/$pairId',
    });

    return (
        <PlotForm
            fieldId={fieldId}
            rxId={rxId}
            pairId={pairId}
            placement="manual"
        />
    )
}
